var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Select } from "../form/select";
import { Input } from "../form/input";
import { IconV2 } from "../icon_v2";
export const Pagination = (_a) => {
    var _b, _c, _d, _e;
    var { id, testId, pageIndex, pageCount, pageSize = 10, totalRows, onPrevPage: gotoPrevPage, onNextPage: gotoNextPage, onGotoPage: gotoPage, onPageSizeChange, onMoreResults } = _a, props = __rest(_a, ["id", "testId", "pageIndex", "pageCount", "pageSize", "totalRows", "onPrevPage", "onNextPage", "onGotoPage", "onPageSizeChange", "onMoreResults"]);
    const [height, setHeight] = useState(window.innerWidth < 640 ? "sm" : "md");
    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerWidth < 640 ? "sm" : "md");
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const layout = (_b = props.layout) !== null && _b !== void 0 ? _b : "default";
    const mobileLayout = (_c = props.mobileLayout) !== null && _c !== void 0 ? _c : "default";
    const canPreviousPage = (_d = props.canPreviousPage) !== null && _d !== void 0 ? _d : pageIndex !== 0;
    const canNextPage = (_e = props.canNextPage) !== null && _e !== void 0 ? _e : (pageCount >= 1 &&
        pageIndex !== pageCount - 1 &&
        pageIndex < pageCount - 1);
    const pageNumberPadding = layout === "compact" ? "px-2 py-1.5" : "px-4 py-2";
    const [currentPageIndex, setCurrentPageIndex] = useState(pageIndex + 1);
    useEffect(() => {
        setCurrentPageIndex(pageIndex + 1);
    }, [totalRows, pageSize, pageIndex]);
    const handlePrevPage = () => {
        if (gotoPrevPage !== undefined) {
            gotoPrevPage();
        }
        setCurrentPageIndex(pageIndex);
    };
    const handleNextPage = () => {
        if (gotoNextPage !== undefined) {
            gotoNextPage();
        }
        setCurrentPageIndex(pageIndex + 2);
    };
    const handleMoreResults = () => {
        if (onMoreResults !== undefined) {
            onMoreResults();
        }
    };
    let simpleLayoutLabel = "";
    if (totalRows !== undefined && totalRows > 0) {
        simpleLayoutLabel = `Showing 1 to ${pageSize > totalRows ? totalRows : pageSize} of ${totalRows} items`;
    }
    else {
        simpleLayoutLabel = "No items to show";
    }
    const hidden = totalRows !== undefined && pageSize >= totalRows ? "hidden" : "";
    const prevNextButtons = (_jsxs("div", { id: "prevNextButtons", className: "space-x-1 self-center", children: [_jsx("button", { id: "previousPage", type: "button", title: "Go to previous page", onClick: () => handlePrevPage(), className: `relative inline-flex items-center rounded-md bg-white text-sm font-medium dark:bg-gray-950 ${pageNumberPadding}`, disabled: canPreviousPage ? false : true, children: _jsx("span", { className: canPreviousPage
                        ? "text-tertiary dark:text-dark-tertiary"
                        : "text-dark-tertiary cursor-not-allowed dark:opacity-60", children: _jsx(IconV2, { type: "fa", icon: {
                            icon: ["far", "chevron-left"],
                            fixedWidth: true,
                            size: "lg",
                        } }) }) }), _jsx("button", { id: "nextPage", type: "button", title: "Go to next page", onClick: () => handleNextPage(), className: `relative inline-flex items-center rounded-md bg-white text-sm font-medium dark:bg-gray-950 ${pageNumberPadding}`, disabled: canNextPage ? false : true, children: _jsx("span", { className: canNextPage
                        ? "text-tertiary dark:text-dark-tertiary"
                        : "text-dark-tertiary cursor-not-allowed dark:opacity-60", children: _jsx(IconV2, { type: "fa", icon: {
                            icon: ["far", "chevron-right"],
                            fixedWidth: true,
                            size: "lg",
                            color: "gray",
                        } }) }) })] }));
    const pageSizeSelection = (_jsx(Select, { id: "paginationPageSize", options: [
            { label: "10 items per page", value: "10" },
            { label: "25 items per page", value: "25" },
            { label: "50 items per page", value: "50" },
            { label: "100 items per page", value: "100" },
        ], label: "Page Size", height: height, hideLabel: true, name: "paginationPageSize", onChange: (e) => {
            const newPageSize = parseInt(e.target.value, 10);
            if (onPageSizeChange) {
                onPageSizeChange(newPageSize);
            }
        }, selected: pageSize.toString() }));
    const pageIndexSelection = (_jsxs("div", { className: "flex flex-row space-x-2", children: [_jsx("div", { className: "self-center", children: "Page" }), _jsx(Input, { id: "pageIndex", type: "number", size: "sm", name: "paginationCurrentPage", height: height, label: "Current Page", min: 1, max: pageCount, hideLabel: true, value: currentPageIndex, onKeyDown: (e) => {
                    if (e.key === "ArrowUp" && pageIndex < pageCount - 1) {
                        if (gotoPage !== undefined) {
                            gotoPage(pageIndex + 1);
                        }
                        setCurrentPageIndex(pageIndex + 2);
                    }
                    else if (e.key === "ArrowDown" && pageIndex > 0) {
                        if (gotoPage !== undefined) {
                            gotoPage(pageIndex - 1);
                        }
                        setCurrentPageIndex(pageIndex);
                    }
                }, onChange: (e) => {
                    const target = e.target;
                    if (target.value !== "" && gotoPage !== undefined) {
                        const newPageIndex = parseInt(e.target.value, 10);
                        // if a number bigger than the max is entered, set currentPageIndex to pageCount
                        if (newPageIndex > pageCount) {
                            gotoPage(pageCount - 1);
                            setCurrentPageIndex(pageCount);
                        }
                        else if (newPageIndex < 1) {
                            gotoPage(0);
                            setCurrentPageIndex(1);
                        }
                        else {
                            gotoPage(newPageIndex - 1);
                            setCurrentPageIndex(newPageIndex);
                        }
                    }
                    if (target.value === "") {
                        setCurrentPageIndex("");
                    }
                } }), _jsxs("div", { className: "self-center", id: "totalPageCount", children: ["of ", pageCount] })] }));
    return (_jsxs("div", { id: id, "data-test-id": testId, className: "text-primaryText dark:text-dark-primaryText w-full bg-white px-0 py-3 text-sm dark:bg-gray-950", "data-eco-component": "pagination", children: [_jsx("div", { className: "block sm:hidden", "data-test-id": `${testId}-mobile`, "data-eco-component": "pagination-mobile", children: mobileLayout === "simple" ? (_jsxs("div", { className: "w-full px-4", children: [_jsx("button", { onClick: handleMoreResults, className: `bg-container-light text-primaryText dark:text-dark-primaryText dark:bg-dark-container-light border-interactive dark:border-dark-interactive stratos-border-focus ${hidden} h-11 w-full rounded-md border text-sm font-bold leading-4 disabled:opacity-50`, children: "More results" }), _jsx("div", { className: "mt-1 text-center text-xs", children: simpleLayoutLabel })] })) : mobileLayout === "compact" ? (_jsxs("div", { className: "flex flex-row justify-between px-4", children: [_jsxs("div", { className: "self-center", children: [totalRows, " items"] }), _jsxs("div", { className: "self-center", id: "pageCountMobileCompact", children: ["Page ", pageIndex + 1, " of ", pageCount] }), prevNextButtons] })) : (_jsxs("div", { className: "flex flex-col", children: [totalRows !== undefined ? (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex flex-row justify-between space-x-2 px-4 py-3", children: [onPageSizeChange !== undefined && pageSizeSelection, _jsxs("div", { className: "ml-2 self-center", children: [totalRows, " total items"] })] }), _jsx("div", { className: "border-light -mx-2 border-t" })] })) : (_jsx("div", { children: " " })), _jsxs("div", { className: "flex flex-row justify-between px-4 py-3 sm:justify-end", children: [pageIndexSelection, prevNextButtons] })] })) }), _jsxs("div", { className: "hidden sm:flex sm:flex-row sm:justify-between", "data-test-id": `${testId}-desktop`, "data-eco-component": "pagination-desktop", children: [totalRows !== undefined && (_jsxs("div", { className: "flex flex-row justify-between space-x-2", children: [onPageSizeChange !== undefined && pageSizeSelection, _jsxs("div", { className: "ml-2 self-center", children: [totalRows, " total items"] })] })), _jsxs("div", { className: "flex flex-row justify-between sm:justify-end", children: [pageIndexSelection, prevNextButtons] })] })] }));
};
export default Pagination;
